import { useTranslation } from 'react-i18next';
import {
  MapEntityEditorViewState,
  Operation,
  selectEditedTerminalData,
  setEditedTerminalDataAction,
  setMapTerminalViewStateAction,
  setSelectedTerminalIdAction,
  useAppAction,
  useAppSelector,
  useLoader,
} from '../../../redux';
import { showSuccessToast } from '../../../utils';
import { TerminalFormState } from '../../StopRegistry/Terminals/TerminalDetails/Components/BasicDetails/Edit/schema';
import { useSetMapObservationDate } from '../Utils/useSetObservationDate';
import { useUpdateTerminalMapDetails } from '../Utils/useUpdateTerminalMapDetails';

export function useTerminalEdit() {
  const { t } = useTranslation();
  const { setIsLoading } = useLoader(Operation.ModifyTerminal);

  const { updateTerminalMapDetails, defaultErrorHandler } =
    useUpdateTerminalMapDetails();

  const editedTerminalData = useAppSelector(selectEditedTerminalData);
  const setEditedTerminalData = useAppAction(setEditedTerminalDataAction);
  const setSelectedTerminalId = useAppAction(setSelectedTerminalIdAction);
  const setMapTerminalViewState = useAppAction(setMapTerminalViewStateAction);

  const setMapObservationDate = useSetMapObservationDate();

  const doUpdateTerminal = async (state: TerminalFormState) => {
    if (!editedTerminalData) {
      return;
    }

    setIsLoading(true);

    try {
      const updatedTerminal = await updateTerminalMapDetails({
        terminal: editedTerminalData,
        state,
        selectedStops: state.selectedStops,
      });

      showSuccessToast(t(($) => $.terminalDetails.editSuccess));
      setMapObservationDate(updatedTerminal);
      setEditedTerminalData(updatedTerminal ?? undefined);
      setSelectedTerminalId(updatedTerminal?.id ?? undefined);
      setMapTerminalViewState(MapEntityEditorViewState.POPUP);
    } catch (err) {
      defaultErrorHandler(err as Error, state);
    }

    setIsLoading(false);
  };

  return {
    doUpdateTerminal,
  };
}
